module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"placeholder":"Filtern nach Belegstyp"},"en":{"placeholder":"Order by Beleg"}}')
  delete Component.options._Ctor
}
